import type { FaireProductEntity } from "../../entity_types/product";

export const p_5e5r8k9m3d: FaireProductEntity = {
  token: "p_5e5r8k9m3d",
  type: "product",
  name: "Chill Cubez Sensory Toys",
  brandToken: "b_f1bkinpani",
  brandName: "NYSLIFE",
  imageUrl:
    "https://cdn.faire.com/fastly/78b6d7fc2843345fd9e5aeded23e7d925ded8f0ecefed7fa50327fa9daf55696.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ec18ade5188de06eb841676c437f8451cfe88bf74465338e258909e7bfa18b33.png",
    "https://cdn.faire.com/fastly/a6b188382314aed853afa8034c571d1c4649b18620f558757695541be5abb51d.jpeg",
  ],
  priceDollars: 2.95,
  description:
    "Comes with 4, 12ct Counter Displays = 48 Pieces \n\nSoft Dough Filled Cube \n\nComes in 4 colors \n\nClear Backpack Clip",
  tags: [],
  msrpDollars: 5.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:58:46.077Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
